import Marquee from 'react-fast-marquee'
import FutureMineralCard from './FutureMineralCard'

export default function FutureMineralCountriesCard({ mineral, lng, link, isGridChild, isMarqueeSlider = true }) {
  const isArabic = lng === 'ar'
  const hasCountries = mineral.countries && mineral.countries.length > 0
  const marqueeDirection = isArabic ? 'right' : 'left'

  // const renderCountries = (countries, direction) => {
  //   const countryList = direction === 'reverse' ? countries : [...countries].reverse()

  //   return countryList.map((country) => (
  //     <img
  //       key={`${mineral.id}-${country.id}`}
  //       className="mr-2 h-[32px] border-2"
  //       src={`${process.env.REACT_APP_API_BASE_URL}/storage/flags/${country.image}`}
  //       alt={country[`name_${lng}`]}
  //     />
  //   ))
  // }


  // const renderCountries = (countries, direction) => {
  //   // 1️⃣  Supprimer les doublons par ID
  //   const uniqueCountries = Array.from(
  //     new Map(countries.map(c => [c.id, c])).values()
  //   );

  //   // 2️⃣  Appliquer la direction
  //   const countryList =
  //     direction === 'reverse'
  //       ? [...uniqueCountries].reverse()
  //       : uniqueCountries;

  //   // 3️⃣  Rendu
  //   return countryList.map((country) => (
  //     <img
  //       key={`${mineral.id}-${country.id}`}
  //       className="mr-2 h-[32px] border-2"
  //       src={`${process.env.REACT_APP_API_BASE_URL}/storage/flags/${country.image}`}
  //       alt={country[`name_${lng}`]}
  //     />
  //   ));
  // };



  const renderCountries = (countries, direction) => {
    if (!Array.isArray(countries)) return null;

    // Enlever les doublons + ignorer les entrées null
    const uniqueCountries = Array.from(
      new Map(
        countries
          .filter(c => c && c.id)       // <-- on enlève null/undefined
          .map(c => [c.id, c])
      ).values()
    );

    // Gérer la direction
    const countryList =
      direction === 'reverse'
        ? uniqueCountries
        : [...uniqueCountries].reverse();

    return countryList.map((country) => {
      // Double check au cas où une clé manque
      const name = country?.[`name_${lng}`] || 'N/A';
      const imgSrc = country?.image
        ? `${process.env.REACT_APP_API_BASE_URL}/storage/flags/${country.image}`
        : '/assets/placeholder-flag.png';

      return (
        <img
          key={`${mineral.id}-${country.id}`}
          className="mr-2 h-[32px] border-2"
          src={imgSrc}
          alt={name}
        />
      );
    });
  };


  return (
    <FutureMineralCard
      mineral={mineral}
      lng={lng}
      link={link}
      isGridChild={isGridChild}
    >
      <div
        dir="ltr"
        className="z-10 bg-muted-300 py-1 group-hover:bg-light"
      >
        {mineral.slug !== 'altylyryom-tellurium' ? (
          hasCountries && (
            // <Marquee
            //   speed={15}
            //   play={true}
            //   direction={marqueeDirection}
            // >
            //   {isArabic ? renderCountries(mineral.countries, 'normal') : renderCountries(mineral.countries, 'reverse')}
            // </Marquee>

            <Marquee speed={15} play direction={marqueeDirection}>
              {isArabic
                ? renderCountries(mineral.countries, 'normal')
                : renderCountries(mineral.countries, 'reverse')}
            </Marquee>

          )
        ) : (
          <div className="h-[40px]" />
        )}
      </div>
    </FutureMineralCard>
  )
}
